// extracted by mini-css-extract-plugin
module.exports = {"item":"DepartmentItem_item__BmOuQ"};